module.exports = clientConfig;